import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material';
import Badge from '@mui/material/Badge';

import { useListConversationsQuery } from '@graphql';
import { useSession, useToastError } from '@hooks';

interface ConversationButtonProps {
  handleOpenDrawer: (event: React.MouseEvent<HTMLElement>) => void;
}

export function ConversationButton(props: Readonly<ConversationButtonProps>) {
  const { handleOpenDrawer } = props;
  const { account } = useSession();
  const toastError = useToastError();
  const theme = useTheme();

  const { data } = useListConversationsQuery({
    skip: !account,
    onError: toastError,
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first',
  });

  const unreadConversations = React.useMemo(() => {
    const conversations = data?.conversations ?? [];
    return conversations.reduce((count, conversation) => {
      return count + (conversation.unreadCount > 0 ? 1 : 0);
    }, 0);
  }, [data?.conversations]);

  return (
    <Tooltip title="Messages">
      <IconButton data-id="inbox" onClick={handleOpenDrawer}>
        <Badge color="error" badgeContent={unreadConversations}>
          <theme.icons.telegram
            sx={{
              color: theme.palette.text.secondary,
              '&:hover': { color: theme.palette.text.primary },
            }}
          />
        </Badge>
      </IconButton>
    </Tooltip>
  );
}
